import { debounce } from './initGlobal';

export default function InitProduct() {
  const appendSizeToWrapper = () => {
    const productTypeSimple = document.querySelector('.product.type-product');
    const productDetailImage = document.querySelector('.product-detail-image');
    const productDetailInfo = document.querySelector('.product-detail-info');

    productTypeSimple.style.setProperty(
      '--offsetHeight',
      `${productDetailImage.clientHeight}px`
    );
    productDetailInfo.style.setProperty(
      '--offsetSelfHeight',
      `${productDetailInfo.clientHeight}px`
    );
  };
  const quantityClick = () => {
    const quantity = document.querySelector('.quantity');
    if (!quantity) return;
    const input = quantity.querySelector('input[type="number"]');
    const step = parseFloat(input.step) || 1;
    const min = parseFloat(input.min) || 1;

    quantity.addEventListener('click', (e) => {
      const { width, left } = quantity.getBoundingClientRect();
      const clickX = e.clientX - left;

      if (clickX < 58) {
        input.value = Math.max(min, parseFloat(input.value) - step);
      } else if (clickX > 92) {
        input.value = parseFloat(input.value) + step;
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };
  window.addEventListener('DOMContentLoaded', () => {
    const info = document.querySelector('.product-detail-info');
    const price = document.querySelector('.product-detail-price');

    if (!info || !price) return;

    const originalParent = info.parentNode;
    const nextSibling = info.nextElementSibling;

    const media = window.matchMedia('(min-width: 1024px)');

    const handleChange = (e) => {
      if (e.matches) {
        // 1024px 이상
        if (!price.contains(info)) price.appendChild(info);
      } else {
        // 1024px 미만
        if (!originalParent.contains(info)) {
          if (nextSibling) {
            originalParent.insertBefore(info, nextSibling);
          } else {
            originalParent.appendChild(info);
          }
        }
      }
    };

    // 초기 상태 반영
    handleChange(media);
    // 변화 감시
    media.addEventListener('change', handleChange);

    appendSizeToWrapper();
    quantityClick();

    info.style.opacity = '1';
  });

  window.addEventListener('resize', debounce(appendSizeToWrapper), {
    passive: true,
  });
}
